import React from 'react'
import { Badge } from 'primereact/badge'

/**
 * Shared body templates for Contact Works tables
 * Used by both ContactWorksStaticTable and ContactWorksNestedTable
 */

/**
 * Get badge class for domain type
 * @param {string} domain - Domain type (TVR, BKA, ART)
 * @returns {string} CSS class for badge
 */
export const getDomainBadgeClass = () => 'custom-badge-base custom-badge-aqua-2'

/**
 * Body template functions for Contact Works table columns
 */
export const contactWorksBodyTemplates = {
    domain: (rowData) => (
        <Badge 
            value={rowData.domain} 
            className={getDomainBadgeClass(rowData.domain)}
        />
    ),

    workTitle: (rowData) => {
        const title = rowData.workTitle || '-'
        return (
            <span className="ellipsis-text" title={title}>
                {title}
            </span>
        )
    },

    episodeTitle: (rowData) => {
        const title = rowData.episodeTitle || '-'
        return (
            <span className="ellipsis-text" title={title}>
                {title}
            </span>
        )
    },

    contributionType: (rowData) => rowData.contributionType || '-',

    workCode: (rowData) => rowData.workCode || '-',

    isbn: (rowData) => rowData.isbn || '-',

    issn: (rowData) => rowData.issn || '-',

    avType: (rowData) => {
        // Only show AV type for TVR (TV/Radio) works
        if (rowData.domain !== 'TVR' || !rowData.avType) {
            return '-'
        }
        return rowData.avType
    },

    addedBy: (rowData) => {
        const addedBy = rowData.addedBy || '-'
        return (
            <span className="ellipsis-text" title={addedBy}>
                {addedBy}
            </span>
        )
    }
}
